<template>
  <div style="display: flex;flex-direction: column;">
    <div>
      <el-button type="primary" @click="getHBLInfo">{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromHBL') }}</el-button>
    </div>
    <cargo-rich-textarea
      v-model="job.cargoEnglishName"
      v-bind="$attrs"
      :disabled="disabled"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'

export default {
  name: 'SeMblCargoEnglishName',
  components: { cargoRichTextarea },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    getHBLInfo() {
      if (!this.job.seaCargoDoc) {
        return
      }
      let hbl = null
      for (const doc of this.job.seaCargoDoc) {
        if (doc.docType === 'HBL') {
          hbl = doc
          break
        }
      }
      if (hbl) {
        this.job.cargoEnglishName = hbl.cargoEnglishName
      }
    }
  }
}
</script>
